(function () {

    'use strict';

    angular.module('Services').service('RequestsRepo', RequestsRepo);

    function RequestsRepo($timeout, $q) {
        let requests = {

        };
        function RequestObj(req, callback) {
            let canceler = $q.defer();
            let request = angular.extend(req, {
                timestamp: new Date().getTime(),
                fetching: true,
                timeout: canceler.promise
            });
            function getProperties() {
                return request;
            }
            function isFetching() {
                return request.fetching;
            }
            function start() {
                request.fetching = true;
            }
            function stop() {
                request.fetching = false;
            }
            function cancel() {
                canceler.resolve();
            }
            this.cancel = cancel;
            this.getProps = getProperties;
            this.isFetching = isFetching;
            this.start = start;
            this.stop = stop;
            this.callback = callback;
        }
        function storeRequest(req, callback) {
            const storedReq = requests[req.url.split('?')[0]];
            if(storedReq && storedReq.isFetching() && storedReq.callback.toString() === callback.toString()){
                storedReq.cancel();
            }
            requests[req.url.split('?')[0]] = new RequestObj(req, callback);
        }
        function endRequest(req) {
            if(requests[req.url.split('?')[0]])
                requests[req.url.split('?')[0]].stop();
        }
        function getStored(req, callback) {
            return requests[req.url.split('?')[0]].getProps();
        }
        return {
            storeRequest,
            endRequest,
            getStored
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/RequestsRepo.js